import React from 'react';
import { Box, Button, Typography, Paper } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';

const FileUploader = ({ onFilesSelected, selectedFiles, onCsvDataLoaded }) => {
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    onFilesSelected(files);
    
    if (files.length > 0) {
      const file = files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        const csv = e.target.result;
        const lines = csv.split('\n').filter(line => line.trim());
        const headers = lines[0].split(',').map(h => h.trim());
        const data = lines.slice(1).map(line => line.split(',').map(cell => cell.trim()));
        onCsvDataLoaded(data, headers);
      };
      reader.readAsText(file);
    }
  };

  return (
    <Paper elevation={2} sx={{ p: 3, mb: 2 }}>
      <Box textAlign="center">
        <input
          accept=".csv"
          style={{ display: 'none' }}
          id="csv-demigrator-file-upload"
          multiple
          type="file"
          onChange={handleFileChange}
        />
        <label htmlFor="csv-demigrator-file-upload">
          <Button
            variant="contained"
            component="span"
            startIcon={<CloudUpload />}
            size="large"
          >
            Select CSV Files
          </Button>
        </label>
        
        {selectedFiles.length > 0 && (
          <Box mt={2}>
            <Typography variant="body2" color="textSecondary">
              Selected: {selectedFiles.map(f => f.name).join(', ')}
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default FileUploader;
